// extracted by mini-css-extract-plugin
export default {"Popular":"Popular_Popular__eEsV3"};